import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { NotFound } from "./pages/NotFound";
import { OnboardingPhotos } from "./pages/OnboardingPhotos";
import { OnboardingWerte } from "./pages/OnboardingWerte";
import { OnboardingSuche } from "./pages/OnboardingSuche";
import { Waitlist } from "./pages/Waitlist";
import { Deck } from "./pages/Deck";
import { MatchesInbox } from "./pages/MatchesInbox";
import { Chat } from "./pages/Chat";
import { Settings } from "./pages/Settings";
import { Abo } from "./pages/Abo";
import { Agb } from "./pages/legal/Agb";
import { Datenschutz } from "./pages/legal/Datenschutz";
import { Impressum } from "./pages/legal/Impressum";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route
        path="/onboarding/fotos"
        element={
          <ProtectedRoute>
            <OnboardingPhotos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding/werte"
        element={
          <ProtectedRoute>
            <OnboardingWerte />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding/suche"
        element={
          <ProtectedRoute>
            <OnboardingSuche />
          </ProtectedRoute>
        }
      />
      <Route
        path="/warteliste"
        element={
          <ProtectedRoute>
            <Waitlist />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deck"
        element={
          <ProtectedRoute>
            <Deck />
          </ProtectedRoute>
        }
      />
      <Route
        path="/matches"
        element={
          <ProtectedRoute>
            <MatchesInbox />
          </ProtectedRoute>
        }
      />
      <Route
        path="/matches/:id"
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route
        path="/einstellungen"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/abo"
        element={
          <ProtectedRoute>
            <Abo />
          </ProtectedRoute>
        }
      />

      <Route path="/legal/agb" element={<Agb />} />
      <Route path="/legal/datenschutz" element={<Datenschutz />} />
      <Route path="/legal/impressum" element={<Impressum />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
